import { render } from "./SingleEffectiveModal.vue?vue&type=template&id=cf5e45c8"
import script from "./SingleEffectiveModal.vue?vue&type=script&lang=js"
export * from "./SingleEffectiveModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/aksoftware/software/haushaltsbuchfrontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__